export default "__VITE_ASSET__ac360575__"